import { Button, Card } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DadosMP, EmailMP, PasswordMP, PhoneMP } from "../../../Icons";
import api from "../../../../services/api";
import "./style.css";
import { CadastroContext } from "../../../../contexts/CadastroContext";
import isNotNullOrEmpty from "../../../../utils/isNotNullOrEmpty";
import AlertMessage from "../../../Alert";
import { Load } from "../../../Load";

const AsoValidarInfoEmpresa = () => {
	const { cadastro, handleCadastroChange, handleCadastroClear } =
		useContext(CadastroContext);
	const { idConsulta } = useParams();
	const [isDisabled, setIsDisabled] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [alert, setAlert] = useState({
		show: false,
		message: "",
		variant: "success",
	});
	const navigate = useNavigate();
	const dados =
		isNotNullOrEmpty(cadastro.cnpj) &&
		isNotNullOrEmpty(cadastro.files) &&
		isNotNullOrEmpty(cadastro.frenteDocumento) &&
		isNotNullOrEmpty(cadastro.versoDocumento);
	const redirectMap: { [key: string]: string } = {
		email: "/aso/registro/validar-email",
		dados: "/aso/registro/validar-cnpj",
		telefone: "/aso/registro/validar-telefone",
		password: "/aso/registro/validar-senha",
	};

	useEffect(() => {
		const fetchData = async () => {
			if (idConsulta && !cadastro.reaproveitamentoAso) {
				cadastro.idConsulta = idConsulta;
				cadastro.isEmpresa = true;
				handleCadastroChange(cadastro);
				const response = await api.get(
					`/buscar-empresa/${encodeURIComponent(cadastro.cnpj)}`,
				);
				const { usuario_id } = response.data;
				cadastro.userId = usuario_id;
				handleCadastroChange(cadastro);
				return navigate(`/`);
			}
		};

		if (
			cadastro.emailValidado &&
			cadastro.cnpjValidado &&
			cadastro.frenteDocumentoValidado &&
			cadastro.versoDocumentoValidado &&
			cadastro.passwordValidada
		) {
			setIsDisabled(false);
		}
		fetchData();
	}, []);

	const handleLimpar = () => {
		handleCadastroClear(cadastro);
		cadastro.idConsulta = idConsulta!;
	};

	const handleFinalizar = () => {
		return cadastro.reaproveitamentoAso ? navigate("/") : envio();
	};

	const envio = async () => {
		try {
			setIsLoading(true);
			const corpo = { ...cadastro, idConsulta };
			const response = await api.post("/criar-usuario", corpo);
			console.log("🚀 ~ envio ~ response:", response);
			if (response.status === 201) {
				const { id } = response.data;
				cadastro.userId = id;
				handleCadastroChange(cadastro);
				setIsLoading(false);
				setAlert({
					show: true,
					message: "Empresa cadastrada com sucesso!",
					variant: "success",
				});
				navigate(`/`);
			}
		} catch (error) {
			setIsLoading(false);
			setAlert({
				show: true,
				message: "Erro ao cadastrar, tente novamente.",
				variant: "danger",
			});
			handleCadastroClear(cadastro);
			cadastro.idConsulta = idConsulta!;
		}
	};

	const handleCardClick = (redirect: any) => navigate(redirect);

	const cardItem = ({
		className,
		icon,
		title,
		subTitle,
		btnText,
		cardActive,
		redirect,
		onCardClick,
	}: any) => {
		return (
			<Card
				className={`mb-1 card-item ${className} ${cardActive === "condition1" ? "card-active" : ""}`}
			>
				<Card.Body className="d-flex align-items-center justify-content-between media-600-column-direction">
					{icon === "email" ? (
						<div
							className={`${!cadastro.emailValidado ? "icon-mp" : "icon-mp-valid"}`}
						>
							<EmailMP />
						</div>
					) : icon === "dados" ? (
						<div className={`${!dados ? "icon-mp" : "icon-mp-valid"}`}>
							<DadosMP />
						</div>
					) : icon === "phone" ? (
						<div
							className={`${!cadastro.telefoneValidado ? "icon-mp" : "icon-mp-valid"}`}
						>
							<PhoneMP />
						</div>
					) : icon === "password" ? (
						<div
							className={`${!cadastro.passwordValidada ? "icon-mp" : "icon-mp-valid"}`}
						>
							<PasswordMP />
						</div>
					) : null}

					<div className="valid-card-group" style={{ flex: 1 }}>
						<Card.Text style={{ fontSize: "14px", margin: 0 }}>
							{title}
						</Card.Text>
						<Card.Text className="text-muted" style={{ fontSize: "12px" }}>
							{subTitle}
						</Card.Text>
					</div>

					{cardActive === "condition1" ? (
						<Button
							variant="primary"
							className="aso-btn-mp"
							onClick={() => {
								navigate(`${redirectMap[redirect]}`);
							}}
						>
							{btnText}
						</Button>
					) : cardActive === "condition2" ? (
						<div className="andes-list__item-second-column">
							<div className="andes-list__item-tertiary-container andes-list__item-tertiary-container--top">
								<span className="andes-list__item-tertiary andes-list__item-tertiary--top">
									<button
										type="button"
										className="andes-button hub-item__button-edit andes-button--medium andes-button--transparent"
										aria-label="Editar"
										onClick={onCardClick}
									>
										<span className="andes-button__content">
											<svg
												aria-hidden="true"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="rgba(0, 0, 0, 0.9)"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M21.807 6.96258L16.9706 2L2 17.0575V21.8211H6.76999L21.807 6.96258ZM16.96 4.13811L19.693 6.94211L18.1783 8.43877L15.4232 5.68368L16.96 4.13811ZM14.3656 6.74736L3.5 17.6751V20.3201H6.154L17.1113 9.49309L14.3656 6.74736Z"
													fill="rgba(0, 0, 0, 0.9)"
												></path>
											</svg>
										</span>
									</button>
								</span>
							</div>
						</div>
					) : (
						<div style={{ border: "none" }}></div>
					)}
				</Card.Body>
			</Card>
		);
	};

	return (
		<>
			<Load isLoading={isLoading} />
			{!isLoading && (
				<Card className="aso-card">
					<Card.Body className="aso-card-body" style={{ padding: "0" }}>
						<div className="icon-text-container d-flex flex-column align-items-center mb-4">
							<Card.Title
								className="cardTitle text-justify"
								style={{ fontSize: "22px", marginTop: 0 }}
							>
								Precisamos validar alguns dados para criar sua conta
							</Card.Title>
						</div>
						{!cadastro.emailValidado
							? cardItem({
									className: "mb-3",
									icon: "email",
									title: "Adicione seu e-mail",
									subTitle: "Você vai receber informações sobre sua conta.",
									btnText: "Adicionar",
									cardActive: "condition1",
									redirect: "email",
								})
							: cardItem({
									className: "mb-3",
									icon: "email",
									title: "E-mail adicionado",
									subTitle: `${cadastro.email}`,
									btnText: "Editar",
									cardActive: "condition2",
									redirect: "email",
									onCardClick: () => handleCardClick("email"),
								})}

						{!dados && cadastro.emailValidado
							? cardItem({
									className: "mb-3",
									icon: "dados",
									title: "Complete os dados da sua empresa",
									subTitle: "Vamos pedir algumas informações e documentos.",
									btnText: "Adicionar",
									cardActive: "condition1",
									redirect: "dados",
								})
							: dados
								? cardItem({
										className: "mb-3",
										icon: "dados",
										title: "Dados da empresa validados",
										subTitle: "Dados da empresa validados com sucesso.",
										btnText: "Editar",
										cardActive: "condition2",
										onCardClick: () => handleCardClick("dados"),
									})
								: cardItem({
										className: "mb-3",
										icon: "dados",
										title: "Complete os dados da sua empresa",
										subTitle: "Vamos pedir algumas informações e documentos.",
										btnText: "Adicionar",
										cardActive: "",
										redirect: "dados",
									})}

						{!cadastro.telefoneValidado &&
						cadastro.frenteDocumentoValidado &&
						cadastro.versoDocumentoValidado
							? cardItem({
									icon: "phone",
									title: "Valide seu telefone",
									subTitle:
										"Você vai usá-lo para receber informações sobre seu ASO",
									btnText: "Validar",
									cardActive: "condition1",
									redirect: "telefone",
								})
							: cadastro.telefoneValidado
								? cardItem({
										icon: "phone",
										title: "Telefone Validado",
										subTitle: `${cadastro.telefone}`,
										btnText: "Editar",
										cardActive: "condition2",
										redirect: "telefone",
										onCardClick: () => handleCardClick("telefone"),
									})
								: cardItem({
										icon: "phone",
										title: "Valide seu telefone",
										subTitle:
											"Você vai usá-lo para receber informações sobre seu ASO",
										btnText: "Validar",
										cardActive: "",
										redirect: "telefone",
									})}

						{!cadastro.passwordValidada && cadastro.telefoneValidado && dados
							? cardItem({
									icon: "password",
									title: "Cadastre uma senha",
									subTitle:
										"Você vai usá-lo para acessar informações sobre seu ASO",
									btnText: "Validar",
									cardActive: "condition1",
									redirect: "password",
								})
							: cadastro.passwordValidada
								? cardItem({
										icon: "password",
										title: "Senha Cadastrada",
										subTitle: `${cadastro.password}`,
										btnText: "Editar",
										cardActive: "condition2",
										redirect: "password",
										onCardClick: () => handleCardClick("password"),
									})
								: cardItem({
										icon: "password",
										title: "Cadastre uma senha",
										subTitle:
											"Você vai usá-lo para acessar informações sobre seu ASO",
										btnText: "Validar",
										cardActive: "",
										redirect: "password",
									})}
					</Card.Body>
					<div className="aso-botoes-finalizar-cad">
						<Button
							variant="primary"
							className="aso-btn-mp"
							onClick={handleLimpar}
						>
							Limpar
						</Button>
						<Button
							variant="primary"
							className="aso-btn-mp"
							onClick={handleFinalizar}
							disabled={isDisabled}
						>
							Finalizar
						</Button>
					</div>
				</Card>
			)}
			<AlertMessage
				show={alert.show}
				message={alert.message}
				variant={alert.variant}
				onClose={() => setAlert({ ...alert, show: false })}
			/>
		</>
	);
};

export default AsoValidarInfoEmpresa;
